// Loads images that opted out of eager fetching (responsive-asset-image with
// `defer: true`, marked .thk-img-defer): they ship with no real srcset so the
// preload scanner can't pull them early - on slow connections Chrome eager-loads
// even loading=lazy images, which starved the LCP on the shared CDN connection.
// Here we swap the real srcset in only when the image scrolls near the viewport.
(function () {
  function load(img) {
    var sizes = img.getAttribute("data-thk-sizes");
    var srcset = img.getAttribute("data-thk-srcset");
    var src = img.getAttribute("data-thk-src");
    if (sizes) img.sizes = sizes;
    if (srcset) img.srcset = srcset;
    if (src) img.src = src;
    img.removeAttribute("data-thk-srcset");
    img.removeAttribute("data-thk-src");
    img.removeAttribute("data-thk-sizes");
    img.removeAttribute("fetchpriority");
    img.classList.remove("thk-img-defer");
  }

  function init() {
    var imgs = [].slice.call(document.querySelectorAll("img.thk-img-defer"));
    if (!imgs.length) return;
    if (!("IntersectionObserver" in window)) {
      imgs.forEach(load);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            load(e.target);
            io.unobserve(e.target);
          }
        });
      },
      // Small margin: load just before they scroll into view. A large margin
      // would fire on initial load for sections only ~200px below the fold,
      // which is exactly what we're avoiding (they'd compete with the LCP).
      { rootMargin: "150px 0px" },
    );
    imgs.forEach(function (i) {
      io.observe(i);
    });
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
